import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Event } from 'interface'
import axiosClient from 'utils/axiosClient'

const initialState: {
  list: Event[]
} = {
  list: [],
}

export const getEvents = createAsyncThunk('Event/getEvents', async () => {
  const { data } = await axiosClient.get('/api/events')
  return data
})
export const getEvent = createAsyncThunk(
  'Event/getEvent',
  async (id: number) => {
    const { data } = await axiosClient.get('/api/events/' + id)
    return data
  }
)

export const EventSlice = createSlice({
  name: 'Event',
  initialState,
  reducers: {
    removeItem(state, { payload }: PayloadAction<number>) {
      const index = state.list.findIndex((f) => f.id === payload)
      if (index >= 0) {
        state.list.splice(index, 1)
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEvents.fulfilled, (state, { payload }) => {
      state.list = payload
    })
    builder.addCase(
      getEvent.fulfilled,
      (state, { payload }: PayloadAction<number | Event>) => {
        if(typeof payload === 'number'){
          const index = state.list.findIndex((f) => f.id === payload)
          state.list.splice(index, 1)
        }else{
          const index = state.list.findIndex((f) => f.id === payload.id)
          if (index < 0) {
            state.list.push(payload)
          } else {
            state.list.splice(index, 1, payload)
          }
        }
      }
    )
  },
})

export const EventAction = EventSlice.actions

export const EventReducer = EventSlice.reducer
